
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export class ResourceDownloader {
  static async downloadContentZip(resourceId: string, topic: string = "Training", company: string = "Company"): Promise<void> {
    try {
      console.log(`Initiating download for resource: ${resourceId}`);
      toast.info("Preparing training materials...");
      
      // Call the Supabase function
      const { data, error } = await supabase.functions.invoke("generate-content-zip", {
        body: { resource_id: resourceId, topic, company }
      });
      
      if (error) {
        console.error("Error calling generate-content-zip function:", error);
        toast.error(`Failed to generate training materials: ${error.message}`);
        return;
      }
      
      if (!data) {
        console.error("No data returned from function");
        toast.error("Failed to generate training materials: No data returned");
        return;
      }
      
      // Process the base64 string from the JSON response
      if (data.data && typeof data.data === 'string') {
        try {
          // Convert base64 to binary data
          const binaryString = atob(data.data);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          
          // Create a blob and download it
          const blob = new Blob([bytes], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
          
          const a = document.createElement('a');
          a.href = url;
          a.download = `${company} - ${topic} Materials.zip`;
          document.body.appendChild(a);
          a.click();
          
          // Clean up
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          
          console.log(`Download completed for resource: ${resourceId}`);
          toast.success("Download complete! Check your downloads folder.");
        } catch (e) {
          console.error("Error processing base64 data:", e);
          toast.error("Failed to process download data. Please try again.");
        }
      } else {
        console.error("Unexpected data format returned:", typeof data);
        toast.error("Received unexpected data format. Please try again.");
      }
    } catch (error) {
      console.error("Error downloading content:", error);
      toast.error("Failed to download content. Please try again later.");
    }
  }
}
